<template>
  <div class="dashboard-container">
    <div class="p-5 d-flex breadcrumHeader">
      <div>
        <v-breadcrumbs :items="['Dashboard']" divider="/">
          <template v-slot:item="{ item }">
            <v-breadcrumbs-item
              @click="(isDrilldown = false), $router.push('/Dashboard')"
              style="cursor: pointer"
            >
              <h2>Dashboard </h2>
            </v-breadcrumbs-item>
            <v-breadcrumbs-item v-if="isDrilldown">
              <h4 style="color: #303361"
                >/ {{ $router.currentRoute.query.chart }}</h4
              >
            </v-breadcrumbs-item>
          </template>
        </v-breadcrumbs>
      </div>
      <div class="px-5">
        <date-range-picker
          id="timeFilter"
          ref="picker"
          v-model="dateRange"
          :opens="opens"
          :locale-data="{ firstDay: 1, format: 'mm/dd/yyyy' }"
          :min-date="minDate"
          :max-date="maxDate"
          :single-date-picker="singleDatePicker"
          :time-picker="timePicker"
          :ranges="quickRanges"
          :time-picker24hour="timePicker24Hour"
          :show-week-numbers="showWeekNumbers"
          :show-dropdowns="showDropdowns"
          :auto-apply="autoApply"
          :linked-calendars="linkedCalendars"
          :date-format="dateFormat"
          control-container-class="px-2 rounded py-1 white"
          @update="handleChange"
        >
          <template v-slot:input="picker">
            <v-input
              prepend-icon="mdi-calendar"
             
              dense
              class="calender-input mx-2"
            >
              {{ picker.startDate | date }} - {{ picker.endDate | date }}
            </v-input>
          </template>
        </date-range-picker>
      </div>
    </div>
    <div v-if="!isDrilldown" class="px-5">
      <div class="chartCard px-5 py-5">
        <h5>No Of Sign Ups</h5>
        <div class="chartCounts">
          <div class="row">
            <div class="col-md-2 col-6 text-center">
              <p>Total Sign ups </p>
              <h5>{{ totalSignups }}</h5>
            </div>
          </div>
        </div>
        <no-of-signups
          v-if="isSignup"
          :chart-data.sync="noofsignups"
          @drilldown="openDrilldown"
        />
      </div>
      <div class="d-flex mt-4">
        <v-row>
          <v-col cols="4">
            <div class="chartCard px-5 py-5">
              <h5>Conversion Rate</h5>
              <conversion-rate
                v-if="isConvo"
                :chart-data.sync="paidConversionRate"
                @drilldown="openDrilldown"
              />
            </div>
          </v-col>

          <v-col cols="8">
            <div class="chartCard px-5 py-5">
              <h5>Early Churn Rate</h5>
              <early-churn-rate
                v-if="ischurn"
                :chart-data.sync="earlyChurnRate"
                @drilldown="openDrilldown"
              />
            </div>
          </v-col>
        </v-row>
      </div>
      <div class="mt-4">
        <v-row>
          <v-col cols="4">
            <div class="chartCard px-5 py-5">
              <h5>Average Users</h5>
              <avg-user
                v-if="isAvgUser"
                :chart-data.sync="avgUsers"
                @drilldown="openDrilldown"
              />
            </div>
          </v-col>

          <v-col cols="8">
            <div class="chartCard px-5 py-5">
              <h5>No Of Direct Users</h5>
              <direct-users
                v-if="isDirect"
                :chart-data.sync="directSignups"
                @drilldown="openDrilldown"
              />
            </div>
          </v-col>
          <v-col cols="4">
            <div class="chartCard px-4 py-4">
              <h5>No Of Invited Users</h5>
              <invite-users-count
                v-if="isInvitedUser"
                :chart-data.sync="numberOfInvitedUsers"
                @drilldown="!openDrilldown"
              />
            </div>
          </v-col>
        </v-row>
      </div>
    </div>
    <div v-else class="px-5">
      <drilldown-chart
        v-if="$router.currentRoute.query.chart === 'NoOfSignups'
            ? isSignup
            : $router.currentRoute.query.chart === 'EarlyChurnRate'
            ? ischurn
            : $router.currentRoute.query.chart === 'DirectUsers'
            ? isDirect
            : $router.currentRoute.query.chart === 'ConversionRate'
            ? isConvo
            : $router.currentRoute.query.chart === 'AvgUser'
            ? isAvgUser            
            : false"
        :drill-chart-data="{
          chartData:
            $router.currentRoute.query.chart === 'NoOfSignups'
              ? noofsignups
              : $router.currentRoute.query.chart === 'EarlyChurnRate'
              ? earlyChurnRate
              : $router.currentRoute.query.chart === 'DirectUsers'
              ? directSignups
              : $router.currentRoute.query.chart === 'ConversionRate'
              ? paidConversionRate
              : $router.currentRoute.query.chart === 'AvgUser'
              ? avgUsers              
              : [],
        }"
        :time-filter.sync="timefilterValues"
      />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import DateRangePicker from 'vue2-daterange-picker';
import moment from 'moment';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import AvgUser from '../Metrics/AvgUser.vue';
import ConversionRate from '../Metrics/ConversionRate.vue';
import DirectUsers from '../Metrics/DirectUsers.vue';
import DrilldownChart from '../Metrics/DrilldownChart.vue';
import EarlyChurnRate from '../Metrics/EarlyChurnRate.vue';
import NoOfSignups from '../Metrics/NoOfSignups.vue';
import InviteUsersCount from '../Metrics/InviteUsersCount.vue';

export default {
  components: {
    NoOfSignups,
    EarlyChurnRate,
    DrilldownChart,
    ConversionRate,
    AvgUser,
    DirectUsers,
    DateRangePicker,
    InviteUsersCount,
  },
  filters: {
    date(val) {
      return val ? val.toLocaleDateString() : '';
    },
  },
  data() {
    return {
      noofsignups: [],
      directSignups: [],
      earlyChurnRate: [],
      paidConversionRate: [],
      avgUsers: [],
      isSignup: false,
      ischurn: false,
      isDrilldown:
        this.$router.currentRoute.query.chart !== undefined || false,
      drilldata: [],
      isConvo: false,
      chartData: [],
      isAvgUser: false,
      isDirect: false,
      totalSignups: 0,
      dateRange: {
        startDate: null,
        endDate: null,
      },
      opens: 'center',
      minDate: null,
      maxDate: null,
      singleDatePicker: false,
      timePicker: true,
      timePicker24Hour: true,
      showWeekNumbers: true,
      showDropdowns: true,
      autoApply: false,
      linkedCalendars: true,
      btnDisableNext: true,
      range: {},
      yearSelect: true,
      timefilterValues: {},
      numberOfInvitedUsers:0,
      isInvitedUser:false,
    };
  },
  computed: {
    quickRanges() {
      let today = new Date();
      today.setHours(0, 0, 0, 0);
      let yesterday = new Date();
      yesterday.setDate(today.getDate() - 1);
      yesterday.setHours(0, 0, 0, 0);
      let monday = new Date();
      var day = monday.getDay() || 7;
      if (day !== 1) {
        monday.setHours(-24 * (day - 1));
      }
      const pastdateByDays = (days) =>
        new Date(Date.now() - days * 24 * 60 * 60 * 1000);

      return {
        'This week': [monday, today],
        'This month': [
          new Date(today.getFullYear(), today.getMonth(), 1),
          new Date(),
        ],
        'This year': [
          new Date(today.getFullYear(), 0, 1),
          new Date(),
        ],
        'Last 7 days': [pastdateByDays(7), today],
        'Last 30 days': [pastdateByDays(30), today],
        'Last 90 days': [pastdateByDays(90), today],
        'Last 180 days': [
          pastdateByDays(180),
          new Date(today.getFullYear(), today.getMonth(), 0),
        ],
        'Last year': [
        new Date(today.getFullYear()-1, 0, 1),
          new Date(today.getFullYear()-1, 11, 31),
        ],
        'Last 2 years': [
          pastdateByDays(730),
          new Date(today.getFullYear(), today.getMonth(), today.getDate()),
        ],
      };
    },
  },
  watch: {
    timefilterValues: {
      handler(val) {
        console.log(val);
        this.getMetricData();
      },
      deep: true,
    },
  },
  async mounted() {
    if(sessionStorage.getItem('dateRange') === null){
    const today = new Date();
    const lastDay = new Date();
    lastDay.setDate(today.getDate() - 30);
    this.timefilterValues.from = moment(lastDay).format('X');
    this.timefilterValues.to = moment(today).format('X');
    this.dateRange.startDate = lastDay;
    this.dateRange.endDate = today;
    }
    else{
        this.dateRange=JSON.parse(sessionStorage.getItem('dateRange'))
        this.timefilterValues=JSON.parse(sessionStorage.getItem('timeFilter'))
    }
    this.getMetricData();
    this.getInvitedUsers();
  },
  methods: {
    ...mapActions({
      getSignupData: 'Marketing/getSignupData',
      getDirectSignups: 'Marketing/getDirectSignups',
      getEarlyChurnRate: 'Marketing/getEarlyChurnRate',
      getPaidConversionRate: 'Marketing/getPaidConversionRate',
      getAvgUsers: 'Marketing/getAvgUsers',
      getInvitedUsersCount:'Marketing/getInvitedUsersCount',
    }),
    async getMetricData() {
      this.isSignup = false;
      await this.getSignupData({
        payLoad: {
          type: 'count',
          timefilter: this.timefilterValues,
        },
      }).then((res) => {
        if (res.status === 200) {
          this.noofsignups = res.data.signupsPerday;
          this.totalSignups = res.data.totalSignupCount;
          this.isSignup = true;
        }
      });
      this.isDirect = false;
      await this.getDirectSignups({
        payLoad: {
          type: 'count',
          timefilter: this.timefilterValues,
        },
      }).then((res) => {
        if (res.status === 200) {
          this.isDirect = true;
          this.directSignups = res.data;
        }
      });
      this.ischurn = false;
      await this.getEarlyChurnRate({
        payLoad: {
          type: 'countByMonth',
          timefilter: this.timefilterValues,
        },
      }).then((res) => {
        if (res.status === 200) {
          this.earlyChurnRate = res.data;
          this.ischurn = true;
        }
      });
      this.isConvo = false;
      await this.getPaidConversionRate({
        payLoad: {
          type: 'count',
          timefilter: this.timefilterValues,
        },
      }).then((res) => {
        if (res.status === 200) {
          this.isConvo = true;
          this.paidConversionRate = res.data.result;
        }
      });
      this.isAvgUser = false;
      await this.getAvgUsers({
        payLoad: {
          type: 'count',
          timefilter: this.timefilterValues,
        },
      }).then((res) => {
        if (res.status === 200) {
          this.isAvgUser = true;
          this.avgUsers = res.data.result;
        }
      });
    },
    openDrilldown(params) {
      this.isDrilldown = true;
     
      this.$router.push(
        `${this.$router.currentRoute.path}?chart=${params.chart}${
          params.value ? '&drilldown=' + params.value : ''
        }`,
      );
    },
    clearDates: function () {
      this.dateRange.startDate = null;
      this.dateRange.endDate = null;

      this.handleChange({});
    },
    dateFormat: function (classes, date) {
      if (!classes.disabled) {
        // classes.disabled = date.getTime() < new Date()
      }
      return classes;
    },
    handleChange: function (values) {
      if (this.dateRange) {
        this.timefilterValues.from = moment(
          new Date(this.dateRange.startDate).setHours(0, 0, 0, 0),
        ).format('X');
        this.timefilterValues.to = moment(
          new Date(this.dateRange.endDate),
        ).format('X');
        this.getMetricData();
      }
      sessionStorage.setItem('timeFilter',JSON.stringify(this.timefilterValues))
      sessionStorage.setItem('dateRange',JSON.stringify(this.dateRange))
     
    },
     
    
    async getInvitedUsers () {
      this.isInvitedUser = false; 
     await this.getInvitedUsersCount().then(res=>{    
      if(res?.status==200){  
        this.isInvitedUser = true;       
       this.numberOfInvitedUsers = res.data.data.usersCount 
           
      }
    })
  },

  },

  
};
</script>

<style lang="scss">
.dashboard-container {
  background-color: #f5f5f5;
  min-height: calc(100vh - 70px);

  .cursor-pointer {
    cursor: pointer;
  }

  .breadcrumHeader {
    justify-content: space-between;
    padding: 8px 10px;
    background-color: #fff;
    border-bottom: 1px solid #bdbdbd;
    margin: 0 0 15px 0;

    h2 {
      padding-left: 10px;
    }
  }

  //   .calender-input /deep/ .v-messages {
  //   display: none !important;
  //     }
  .calender-input{
    align-items: center;
  }
  .chartCard {
    background-color: #fff;
    height: 100%;

    h5 {
      font-size: 18px;
      font-weight: 600;
    }

    .chartCounts {
      background-color: #f5f5f5;
      padding: 10px 15px;
      margin: 10px 0 0 0;

      p {
        margin-bottom: 0px;
        font-size: 12px;
        color: #666;
      }

      h5 {
        color: #121212;
        font-weight: 700;
        font-size: 20px;
      }
    }
  }
}

.daterangepicker.openscenter {
  left: -160px !important;
}

.daterangepicker.openscenter:after {
  margin-right: 100px !important;
}

.daterangepicker.openscenter:before {
  margin-right: 99px !important;
}
</style>
<style scoped>
.calender-input /deep/ .v-messages {
  display: none !important;

}
</style>